import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from './ui/Dialog';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { Label } from './ui/Label';
import { Textarea } from './ui/Textarea';
import { ArrowRight } from 'lucide-react';
interface ContactDialogProps {
  children: React.ReactNode;
}
export function ContactDialog({
  children
}: ContactDialogProps) {
  const [formData, setFormData] = useState({
    nom: '',
    email: '',
    organisation: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Contact form submitted:', formData);
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <Dialog data-id="element-20">
      <DialogTrigger asChild data-id="element-21">{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[500px] bg-[#09090B] border-white/[0.12] z-[100]" data-id="element-22">
        <DialogHeader data-id="element-23">
          <DialogTitle className="text-2xl font-bold text-white font-heading" data-id="element-24">
            Nous contacter
          </DialogTitle>
          <DialogDescription className="text-white/60" data-id="element-25">
            Vous avez une question ? Notre équipe MeetOS est là pour vous aider.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4" data-id="element-26">
          <div className="space-y-2" data-id="element-27">
            <Label htmlFor="contact-nom" className="text-white/70" data-id="element-28">
              Nom *
            </Label>
            <Input id="contact-nom" name="nom" required value={formData.nom} onChange={handleChange} className="bg-white/[0.05] border-white/[0.12] text-white placeholder-white/30 focus:border-cyan-500/50 focus:ring-cyan-500/20" placeholder="Votre nom" data-id="element-29" />
          </div>

          <div className="space-y-2" data-id="element-30">
            <Label htmlFor="contact-email" className="text-white/70" data-id="element-31">
              Email *
            </Label>
            <Input id="contact-email" name="email" type="email" required value={formData.email} onChange={handleChange} className="bg-white/[0.05] border-white/[0.12] text-white placeholder-white/30 focus:border-cyan-500/50 focus:ring-cyan-500/20" placeholder="votre@email.com" data-id="element-32" />
          </div>

          <div className="space-y-2" data-id="element-33">
            <Label htmlFor="contact-organisation" className="text-white/70" data-id="element-34">
              Organisation *
            </Label>
            <Input id="contact-organisation" name="organisation" required value={formData.organisation} onChange={handleChange} className="bg-white/[0.05] border-white/[0.12] text-white placeholder-white/30 focus:border-cyan-500/50 focus:ring-cyan-500/20" placeholder="Votre organisation" data-id="element-35" />
          </div>

          <div className="space-y-2" data-id="element-36">
            <Label htmlFor="contact-message" className="text-white/70" data-id="element-37">
              Message *
            </Label>
            <Textarea id="contact-message" name="message" required rows={4} value={formData.message} onChange={handleChange} className="bg-white/[0.05] border-white/[0.12] text-white placeholder-white/30 focus:border-cyan-500/50 focus:ring-cyan-500/20 resize-none" placeholder="Comment pouvons-nous vous aider ?" data-id="element-38" />
          </div>

          <Button type="submit" className="w-full bg-gradient-to-r from-cyan-500 to-blue-500 hover:from-cyan-600 hover:to-blue-600 text-white border-0" data-id="element-39">
            Envoyer le message
            <ArrowRight className="ml-2 h-4 w-4" data-id="element-40" />
          </Button>
        </form>
      </DialogContent>
    </Dialog>;
}